import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const RouteManager = () => {
  const { currentUser, isProfileComplete, loading } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading Session...
      </div>
    );
  }

  const authRedirectPaths = [
    "/login",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/verify-email",
  ];
  const fullyPublicPaths = [
    "/",
    "/landingpage",
    "/coming-soon",
    "/oauth-callback",
  ];
  const dashboardPath = "/dashboard";
  const profileSetupPath = "/profile-setup";

  // --- LOGIC FOR LOGGED-IN USERS ---
  if (currentUser && currentUser.id) {
    // Rule 1: If a logged-in user is on a page meant ONLY for logged-out users (like /login),
    // redirect them to their appropriate main page.
    if (authRedirectPaths.includes(currentPath) || currentPath === "/") {
      const intendedPath = isProfileComplete ? dashboardPath : profileSetupPath;
      console.log(
        `[RouteManager] Auth user on auth-only page. Redirecting to: ${intendedPath}`
      );
      return <Navigate to={intendedPath} replace />;
    }

    // Rule 2: If a user's profile is INCOMPLETE, and they are trying to access ANY page
    // that ISN'T the setup page, force them to the setup page. This is for initial onboarding.
    if (!isProfileComplete && currentPath !== profileSetupPath) {
      console.log(
        `[RouteManager] Auth user, profile incomplete. Forcing redirect to: ${profileSetupPath}`
      );
      return <Navigate to={profileSetupPath} replace />;
    }

    // --- START OF FIX ---
    // The previous rule that redirected complete users AWAY from /profile-setup has been REMOVED.
    // By removing that rule, we now allow a user with a complete profile to visit /profile-setup
    // if they navigate there directly (e.g., from an "Edit Profile" link).
    // --- END OF FIX ---

    // Rule 3 (Default): If none of the above redirect rules have been met, the user is
    // allowed to be on the page they requested. This now includes a complete user
    // visiting /profile-setup.
    return <Outlet />;
  } else {
    // --- LOGIC FOR LOGGED-OUT USERS ---

    const isPublic =
      fullyPublicPaths.includes(currentPath) ||
      authRedirectPaths.includes(currentPath);

    // If the path is public, let them through.
    if (isPublic) {
      return <Outlet />;
    }

    // Otherwise, it's a protected route. Redirect to the landing page.
    console.log(
      `[RouteManager] Unauth user on protected path '${currentPath}'. Redirecting to '/landingpage'.`
    );
    return <Navigate to="/landingpage" replace />;
  }
};

export default RouteManager;
